export default __webpack_public_path__ + "static/media/ceiling_fan011.fa257ad8.png";